<template>
    <div :class="`scc-container__column scc-container__sm-column--${sm} scc-container__lg-column--${lg}`">
        <div class="feature" :class="[inverted ? 'feature--inverted' : null]">
            <div class="feature__icon">
                <img v-if="icon" :src="icon" alt="Icon" />
            </div>
            <p class="feature__title bold">{{ text }}</p>
        </div>
    </div>
</template>

<script>
import './feature.scss';

export default {
    name: 'Feature',
    __editor: {
        fields: {
            icon: {
                widget: 'media',
            },
        },
    },
    props: {
        lg: {
            type: Number,
            default: 3,
        },
        sm: {
            type: Number,
            default: 6,
        },
        text: {
            type: String,
            default: 'De mooiste features meteen in je inbox',
        },
        icon: String,
        inverted: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>
